import { Component, Input } from '@angular/core';
import { IExternalProjectData } from '@models/Consumers';
import { ExternalDataUtils } from '@utils/ExternalDataUtils';

/**
 * Selo de origem de um campo obtido de uma integração externa (atualmente AMA / Autenticação.Gov). Só aparece se o campo `path` foi obtido da integração (IdProject raiz = 8).
 * O pai deve ter `position: relative` (ex.: ion-item) — a menos que `inline` seja true.
 */
@Component({
    selector: 'external-integration-badge',
    templateUrl: './external-integration-badge.component.html',
    styleUrls: ['./external-integration-badge.component.scss'],
})
export class ExternalIntegrationBadgeComponent {

    /** IdProject raiz do pedido/consumidor (AMA = 8) */
    @Input('idProject') IdProject: number = null;

    /** Dados da integração (resultado do parse de ProjectExternalData) */
    @Input('data') Data: IExternalProjectData = null;

    /** Caminho do campo em Data, ex.: 'Name' ou 'Location.Address' */
    @Input('path') Path: string = '';

    /** Valor atual do campo; se indicado, o selo só aparece quando igual ao valor da integração */
    @Input('current') Current: any = undefined;

    @Input('inline') Inline: boolean = false;

    /** Logo branco, requer fundo escuro; vazio = ícone Ionic por defeito */
    public IconSrc: string = 'assets/images/logo-ag-symbol.svg';

    public get Visible(): boolean {
        if (!ExternalDataUtils.IsFromAma(this.IdProject, this.Data, this.Path)) return false;

        if (this.Current === undefined) return true;

        return this.Current === this.Path.split('.').reduce((acc: any, key) => acc?.[key], this.Data);
    }
}
